/* Beelonia Videoseite (Section beelonia-videos), 21.10.2026
   Bühne mit YouTube-Player und stummem Hintergrundvideo, Reihen mit Vorschau beim Überfahren,
   Suche, Sprachwahl je Kanal, Teilen mit Sprachauswahl, Produkte aus der Videobeschreibung.
   Daten kommen als JSON aus der Section ([data-bv-daten]), siehe beelonia-videos.liquid. */
(function () {
  var root = document.querySelector('[data-bv]');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-bv-daten]').textContent);
  var K = D.katalog;
  if (!K || !K.videos) return;
  var T = D.texte;

  var buehne = root.querySelector('[data-bv-buehne]');
  var player = root.querySelector('[data-bv-player]');
  var hintergrundBox = root.querySelector('[data-bv-hintergrund]');
  var dialog = root.querySelector('[data-bv-dialog]');
  var vorschau = root.querySelector('[data-bv-vorschau]');
  var sprache = D.sprache;
  var aktuell = D.start;
  var startTitel = document.title;
  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mitMaus = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');

  // Teiltext in der Sprache der Empfänger
  var TEILTEXT = {
    de: 'Schau dir dieses Video von Beelonia an',
    en: 'Have a look at this Beelonia video',
    it: 'Guarda questo video di Beelonia',
    fr: 'Regarde cette vidéo de Beelonia',
    nl: 'Bekijk deze video van Beelonia',
    es: 'Mira este vídeo de Beelonia',
    pt: 'Veja este vídeo da Beelonia',
    da: 'Se denne video fra Beelonia',
    no: 'Se denne videoen fra Beelonia',
    nb: 'Se denne videoen fra Beelonia',
    sv: 'Titta på den här videon från Beelonia',
    pl: 'Zobacz ten film od Beelonia'
  };

  function sprachDaten(code) {
    for (var i = 0; i < K.languages.length; i++) if (K.languages[i].code === code) return K.languages[i];
    return null;
  }

  /** Alle Sprachfassungen eines Videos: { de: id, en: id, … } */
  function fassungen(id) {
    var v = K.videos[id];
    var out = {};
    if (!v) return out;
    Object.keys(K.videos).forEach(function (vid) {
      var w = K.videos[vid];
      if (w.g === v.g && !out[w.l]) out[w.l] = vid;
    });
    out[v.l] = id;
    return out;
  }

  function pfad(id, wurzel) {
    return (wurzel == null ? D.wurzel : wurzel) + '/pages/' + K.url_handle + '/' + K.videos[id].h;
  }

  /** Link für Empfänger: Shop in ihrer Sprache, falls es ihn gibt, sonst die Hauptsprache */
  function teilLink(id, code) {
    var w = D.wurzeln && D.wurzeln[code] != null ? D.wurzeln[code] : '';
    return D.basis + pfad(id, w);
  }

  function bildUrl(url, breite) {
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }

  function dauer(s) {
    return s < 60 ? s + ' ' + T.sek : Math.floor(s / 60) + ' ' + T.min;
  }

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }

  function symbol(auswahl) {
    var vorlage = root.querySelector(auswahl);
    return vorlage ? vorlage.cloneNode(true) : document.createTextNode('');
  }

  /** Höhe der festen Leisten des Themes oben (Desktop: rote Navigation, Handy: Kopfzeile) */
  function leistenHoehe() {
    var hoehe = 0;
    ['.wrapper-navigation', '.header-bottom'].forEach(function (auswahl) {
      var e = document.querySelector(auswahl);
      if (e && e.offsetHeight < 120) hoehe = Math.max(hoehe, e.offsetHeight);
    });
    return hoehe;
  }

  /** Bühne mit Suchfeld und Player unter die feste Leiste des Themes scrollen, nicht dahinter */
  function scrolleZurBuehne() {
    var ziel = root.getBoundingClientRect().top + window.scrollY - leistenHoehe();
    window.scrollTo({ top: Math.max(0, ziel), behavior: wenigBewegung.matches ? 'auto' : 'smooth' });
  }

  // ------------------------------------------------------------ Produkte aus der Videobeschreibung

  var preisFormat = new Intl.NumberFormat(document.documentElement.lang || D.ui || 'de', {
    style: 'currency',
    currency: D.waehrung || 'EUR'
  });

  function preisText(p) {
    var text = (p.price_varies ? T.ab + ' ' : '') + preisFormat.format(p.price / 100);
    var v = p.variants && p.variants[0];
    var m = v && v.unit_price_measurement;
    if (v && v.unit_price && m && m.reference_unit) {
      text += ' (' + preisFormat.format(v.unit_price / 100) + ' / ' + (m.reference_value > 1 ? m.reference_value + ' ' : '') + m.reference_unit + ')';
    }
    return text;
  }

  function kurztext(html, max) {
    var text = new DOMParser().parseFromString(html || '', 'text/html').body.textContent || '';
    text = text.replace(/\[[^\]]*\]/g, ' ').replace(/\s+/g, ' ').trim();
    return text.length > max ? text.slice(0, max).replace(/\s+\S*$/, '') + ' …' : text;
  }

  var produktCache = {};
  function produkt(handle) {
    if (!produktCache[handle]) {
      produktCache[handle] = fetch(D.wurzel + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return produktCache[handle];
  }

  function produkteZu(id) {
    var handles = (K.videos[id] && K.videos[id].pr) || [];
    return Promise.all(handles.map(produkt)).then(function (liste) {
      return liste.filter(function (p) { return p && p.handle; });
    });
  }

  function produktLink(p) {
    return D.wurzel + '/products/' + p.handle;
  }

  /** kleine Karte: Bild, „Im Video“, Name, Preis */
  function produktKarte(p) {
    var a = el('a', 'bv-produkt');
    a.href = produktLink(p);
    if (p.featured_image) {
      var img = el('img');
      img.src = bildUrl(p.featured_image, 120);
      img.alt = '';
      img.width = 52;
      img.height = 52;
      img.loading = 'lazy';
      a.appendChild(img);
    }
    var txt = el('span');
    txt.append(el('small', '', T.imVideo), el('strong', '', p.title), el('em', '', preisText(p)));
    a.appendChild(txt);
    return a;
  }

  /** große Kachel unter dem Player: Bilder, Name, Preis mit Pflichtangaben, Kurzbeschreibung */
  function produktKachel(p) {
    var kachel = el('div', 'bv-kachel');
    var bilder = el('div', 'bv-kachel__bilder');
    (p.images || []).slice(0, 4).forEach(function (src, i) {
      var a = el('a');
      a.href = produktLink(p);
      a.tabIndex = -1;
      a.setAttribute('aria-hidden', 'true');
      var img = el('img');
      img.src = bildUrl(src, i === 0 ? 600 : 200);
      img.alt = '';
      img.loading = 'lazy';
      a.appendChild(img);
      bilder.appendChild(a);
    });
    var text = el('div', 'bv-kachel__text');
    var titel = el('a', 'bv-kachel__titel', p.title);
    titel.href = produktLink(p);
    var hinweis = el('p', 'bv-kachel__hinweis', T.mwst + ' ');
    var versand = el('a', '', T.versand);
    versand.href = D.versandUrl;
    hinweis.appendChild(versand);
    var beschreibung = kurztext(p.description, 220);
    var knopf = el('a', 'bv-knopf bv-knopf--hell', T.zumProdukt);
    knopf.href = produktLink(p);
    text.append(el('small', '', T.imVideo), titel, el('p', 'bv-kachel__preis', preisText(p)), hinweis);
    if (beschreibung) text.appendChild(el('p', 'bv-kachel__beschreibung', beschreibung));
    text.appendChild(knopf);
    kachel.append(bilder, text);
    return kachel;
  }

  function produkte(id) {
    var karten = buehne && buehne.querySelector('[data-bv-produkte]');
    var kacheln = buehne && buehne.querySelector('[data-bv-kacheln]');
    if (!karten || !kacheln) return;
    karten.hidden = kacheln.hidden = true;
    karten.replaceChildren();
    kacheln.replaceChildren();
    produkteZu(id).then(function (liste) {
      if (aktuell !== id || !liste.length) return;
      liste.forEach(function (p) {
        karten.appendChild(produktKarte(p));
        kacheln.appendChild(produktKachel(p));
      });
      karten.hidden = kacheln.hidden = false;
    });
  }

  // ------------------------------------------------------------ stummes Hintergrundvideo auf der Bühne

  var hg = { player: null, id: null, start: 0, timer: null, sichtbar: true };
  var youtubeApi = null;

  /** Nicht bei abgelehnten Marketing-Cookies, reduzierter Bewegung oder Datensparmodus */
  function hintergrundErlaubt() {
    if (!hintergrundBox || wenigBewegung.matches) return false;
    var netz = navigator.connection;
    if (netz && (netz.saveData || /(^|-)2g$/.test(netz.effectiveType || ''))) return false;
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.currentVisitorConsent === 'function') {
        var stand = api.currentVisitorConsent() || {};
        if (stand.marketing === 'no' || stand.preferences === 'no') return false;
      }
    } catch (e) {}
    return true;
  }

  function ladeYoutubeApi() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (!youtubeApi) {
      youtubeApi = new Promise(function (fertig, fehler) {
        var vorher = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof vorher === 'function') vorher();
          fertig();
        };
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        s.async = true;
        s.onerror = fehler;
        document.head.appendChild(s);
      });
    }
    return youtubeApi;
  }

  function starteHintergrund(id) {
    if (!hintergrundErlaubt() || root.classList.contains('is-suche') || buehne.classList.contains('is-spielt')) return;
    var v = K.videos[id];
    if (!v || v.f === 'short') {
      stoppeHintergrund();
      return;
    }
    if (hg.id === id) return;
    stoppeHintergrund();
    hg.id = id;
    // längere Videos beginnen mit Vorspann und Titeltafel: erst nach rund einem Sechstel einsteigen
    hg.start = v.s >= 90 ? Math.min(60, Math.floor(v.s / 6)) : Math.floor(v.s / 10);
    ladeYoutubeApi().then(function () {
      if (hg.id !== id) return;
      var ziel = el('div');
      hintergrundBox.replaceChildren(ziel);
      hg.player = new window.YT.Player(ziel, {
        host: 'https://www.youtube-nocookie.com',
        videoId: id,
        playerVars: { autoplay: 1, mute: 1, controls: 0, disablekb: 1, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, rel: 0, start: hg.start },
        events: {
          onReady: function (e) {
            e.target.mute();
            if (hg.sichtbar) e.target.playVideo();
            var f = hintergrundBox.querySelector('iframe');
            if (f) f.setAttribute('tabindex', '-1');
          },
          onStateChange: function (e) {
            if (hg.id !== id) return;
            clearTimeout(hg.timer);
            if (e.data === 1) {
              // stumm abgespielte Videos zeigen sonst automatisch Untertitel
              try { e.target.unloadModule('captions'); e.target.unloadModule('cc'); } catch (err) {}
              // erst einblenden, wenn YouTube Titelleiste und Symbole ausgeblendet hat
              hg.timer = setTimeout(function () {
                if (hg.id !== id) return;
                hintergrundBox.classList.add('is-an');
                buehne.classList.add('hat-hintergrund');
              }, 2000);
            } else {
              // bei Pause, Puffern oder Ende zeigt YouTube seine Bedienelemente: dann das Standbild davor
              hintergrundBox.classList.remove('is-an');
              buehne.classList.remove('hat-hintergrund');
              if (e.data === 0) {
                e.target.seekTo(hg.start, true);
                e.target.playVideo();
              }
            }
          }
        }
      });
    }).catch(function () {});
  }

  function stoppeHintergrund() {
    clearTimeout(hg.timer);
    hg.id = null;
    if (hg.player && hg.player.destroy) {
      try { hg.player.destroy(); } catch (e) {}
    }
    hg.player = null;
    if (hintergrundBox) {
      hintergrundBox.classList.remove('is-an');
      hintergrundBox.replaceChildren();
    }
    if (buehne) buehne.classList.remove('hat-hintergrund');
  }

  function hintergrundLaeuft(an) {
    hg.sichtbar = an;
    if (!hg.player || typeof hg.player.playVideo !== 'function') return;
    if (an) hg.player.playVideo();
    else hg.player.pauseVideo();
  }

  // ------------------------------------------------------------ Bühne

  function zeige(id, opt) {
    opt = opt || {};
    var v = K.videos[id];
    if (!v || !buehne) return;
    aktuell = id;

    var bild = buehne.querySelector('[data-bv-bild]');
    if (bild && bild.dataset.id !== id) {
      bild.dataset.id = id;
      bild.srcset = [640, 960, 1280].map(function (w) { return bildUrl(v.img, w) + ' ' + w + 'w'; }).join(', ');
      bild.src = bildUrl(v.img, 1280);
    }
    buehne.querySelector('[data-bv-titel]').textContent = v.t;
    var text = buehne.querySelector('[data-bv-text]');
    text.textContent = v.d || '';
    text.hidden = !v.d;

    var meta = buehne.querySelector('[data-bv-meta]');
    meta.replaceChildren(el('span', '', v.p.slice(0, 4)), el('span', '', dauer(v.s)));
    if (K.languages.length > 1) {
      var l = sprachDaten(v.l);
      meta.appendChild(el('span', 'bv-meta__sprache', l ? l.label : v.l));
    }
    buehne.querySelector('[data-bv-play] ~ [data-bv-teilen]').dataset.bvTeilen = id;
    buehne.classList.toggle('is-hoch', v.f === 'short');

    root.querySelectorAll('[data-bv-karte]').forEach(function (k) {
      k.classList.toggle('is-aktiv', k.dataset.bvKarte === id);
    });

    if (opt.abspielen) abspielen();
    else {
      stoppe();
      starteHintergrund(id);
    }
    produkte(id);

    if (opt.verlauf) {
      history.pushState({ bv: id }, '', pfad(id));
    }
    document.title = !opt.verlauf && id === D.start ? startTitel : v.t + ' – ' + D.shopName;
  }

  function abspielen() {
    var v = K.videos[aktuell];
    if (!v) return;
    stoppeHintergrund();
    var q = 'autoplay=1&rel=0&playsinline=1&modestbranding=1&hl=' + encodeURIComponent(D.ui);
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(aktuell) + '?' + q;
    f.title = v.t;
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen; web-share';
    f.setAttribute('allowfullscreen', '');
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    player.replaceChildren(f);
    buehne.classList.add('is-spielt');
  }

  function stoppe() {
    if (player) player.replaceChildren();
    if (buehne) buehne.classList.remove('is-spielt');
  }

  // ------------------------------------------------------------ Sprache

  var sprachwahl = root.querySelector('[data-bv-sprachwahl]');

  function setzeSprache(code, opt) {
    opt = opt || {};
    if (!sprachDaten(code)) return;
    var lief = buehne && buehne.classList.contains('is-spielt');
    sprache = code;
    if (sprachwahl) sprachwahl.value = code;
    root.querySelectorAll('[data-bv-reihen]').forEach(function (r) {
      r.hidden = r.dataset.bvReihen !== code;
    });
    if (root.classList.contains('is-suche')) suche(suchFeld.value);
    else schliesseVorschlaege();
    if (opt.ohneBuehne) return;
    var gegenstueck = fassungen(aktuell)[code];
    var ziel = gegenstueck || sprachDaten(code).featured;
    // Läuft ein Video und gibt es das in der neuen Sprache, läuft es in der neuen Sprache weiter
    zeige(ziel, { abspielen: Boolean(lief && gegenstueck), verlauf: opt.verlauf !== false });
  }

  if (sprachwahl) {
    sprachwahl.addEventListener('change', function () {
      if (sprachwahl.value !== sprache) setzeSprache(sprachwahl.value);
    });
  }

  // ------------------------------------------------------------ Suche: Vorschläge unter dem Feld, Enter zeigt alle Treffer

  var suchFeld = root.querySelector('[data-bv-suche]');
  var suchLeeren = root.querySelector('[data-bv-suche-leeren]');
  var vorschlagBox = root.querySelector('[data-bv-vorschlaege]');
  var treffer = root.querySelector('[data-bv-treffer]');
  var suchIndex = {};
  var suchTimer = null;
  var vorschlagAktiv = -1;
  var MAX_VORSCHLAEGE = 6;

  /** klein, ohne Akzente; „ae“ und „ä“ gelten gleich, damit „raeucher“ und „räucher“ beide treffen */
  function normal(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }

  function woerterVon(text) {
    return normal(text).split(/[^a-z0-9]+/).filter(Boolean);
  }

  var vokabular = null;

  function suchEintrag(id) {
    if (!suchIndex[id]) {
      var v = K.videos[id];
      suchIndex[id] = { t: woerterVon(v.t), k: new Set(woerterVon((v.d || '') + ' ' + (v.k || ''))) };
    }
    return suchIndex[id];
  }

  function baueVokabular() {
    if (vokabular) return vokabular;
    vokabular = new Set();
    Object.keys(K.videos).forEach(function (id) {
      var e = suchEintrag(id);
      e.t.forEach(function (w) { vokabular.add(w); });
      e.k.forEach(function (w) { vokabular.add(w); });
    });
    return vokabular;
  }

  /** erlaubte Tippfehler je Wortlänge: kurze Wörter exakt, ab 5 Buchstaben einer, ab 8 zwei */
  function fehlerGrenze(laenge) {
    return laenge >= 8 ? 2 : laenge >= 5 ? 1 : 0;
  }

  /** Damerau-Levenshtein (fehlend, zusätzlich, falsch, vertauscht); bricht ab, sobald max überschritten ist */
  function abstand(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var vorvorher = [], vorher = [], jetzt = [];
    for (var j = 0; j <= b.length; j++) vorher[j] = j;
    for (var i = 1; i <= a.length; i++) {
      jetzt = [i];
      var kleinster = i;
      for (j = 1; j <= b.length; j++) {
        var kosten = a[i - 1] === b[j - 1] ? 0 : 1;
        var wert = Math.min(vorher[j] + 1, jetzt[j - 1] + 1, vorher[j - 1] + kosten);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) wert = Math.min(wert, vorvorher[j - 2] + 1);
        jetzt[j] = wert;
        if (wert < kleinster) kleinster = wert;
      }
      if (kleinster > max) return max + 1;
      vorvorher = vorher;
      vorher = jetzt;
    }
    return vorher[b.length];
  }

  /** Wörter im Bestand, die zu einem Suchwort passen: exakt (auch als Wortteil) oder mit wenigen Tippfehlern */
  var wortCache = {};
  function passendeWoerter(w) {
    if (wortCache[w]) return wortCache[w];
    var exakt = new Set();
    var unscharf = new Map();
    var max = fehlerGrenze(w.length);
    baueVokabular().forEach(function (t) {
      if (t.indexOf(w) > -1) {
        exakt.add(t);
        return;
      }
      if (!max || t.length < w.length - max) return;
      // auch Teile zusammengesetzter Wörter vergleichen („raucherofn“ in „profiraucherofen“)
      var bester = max + 1;
      for (var i = 0; i <= t.length - (w.length - max) && bester > 0; i++) {
        for (var l = w.length - max; l <= w.length + max && i + l <= t.length; l++) {
          var d = abstand(w, t.substr(i, l), max);
          if (d < bester) bester = d;
        }
      }
      if (bester <= max) unscharf.set(t, bester);
    });
    return (wortCache[w] = { exakt: exakt, unscharf: unscharf });
  }

  /**
   * Videos der gewählten Sprache, in denen jedes Suchwort vorkommt, exakt oder mit Tippfehlern.
   * Titel zählen mehr als die Beschreibung, exakte Treffer mehr als unscharfe. Unscharfe Treffer in der
   * Beschreibung zählen nur, wenn das Wort nirgends exakt vorkommt (sonst zu viel Rauschen bei kurzen Wörtern).
   */
  function finde(roh) {
    var suchwoerter = woerterVon(roh);
    if (!suchwoerter.length) return [];
    var passend = suchwoerter.map(passendeWoerter);
    var liste = [];
    Object.keys(K.videos).forEach(function (id) {
      var v = K.videos[id];
      if (v.l !== sprache) return;
      var e = suchEintrag(id);
      var punkte = 0;
      for (var i = 0; i < suchwoerter.length; i++) {
        var p = passend[i];
        var bester = 0;
        e.t.forEach(function (t) {
          if (p.exakt.has(t)) bester = Math.max(bester, t.indexOf(suchwoerter[i]) === 0 ? 12 : 10);
          else if (p.unscharf.has(t)) bester = Math.max(bester, 7 - 2 * p.unscharf.get(t));
        });
        if (!bester) {
          e.k.forEach(function (t) {
            if (p.exakt.has(t)) bester = Math.max(bester, 3);
            else if (!p.exakt.size && p.unscharf.has(t)) bester = Math.max(bester, 3 - p.unscharf.get(t));
          });
        }
        if (!bester) return;
        punkte += bester;
      }
      liste.push({ id: id, punkte: punkte, p: v.p });
    });
    return liste.sort(function (a, b) { return b.punkte - a.punkte || b.p.localeCompare(a.p); });
  }

  function inAnfuehrung(text) {
    return D.ui === 'de' ? '„' + text + '“' : '“' + text + '”';
  }

  function karteFuer(id) {
    var vorlage = root.querySelector('[data-bv-reihen] .bv-karte:not(.bv-karte--rang)[data-bv-karte="' + id + '"]') ||
      root.querySelector('[data-bv-reihen] .bv-karte[data-bv-karte="' + id + '"]');
    if (!vorlage) return null;
    var k = vorlage.cloneNode(true);
    k.classList.remove('bv-karte--rang', 'is-aktiv');
    var rang = k.querySelector('.bv-rang');
    if (rang) rang.remove();
    return k;
  }

  function vorschlaege(eingabe) {
    var roh = String(eingabe || '').trim();
    suchLeeren.hidden = !roh;
    if (roh.length < 2) {
      schliesseVorschlaege();
      return;
    }
    var liste = finde(roh);
    vorschlagBox.replaceChildren();
    vorschlagAktiv = -1;
    suchFeld.removeAttribute('aria-activedescendant');
    if (!liste.length) {
      vorschlagBox.appendChild(el('p', 'bv-vorschlaege__leer', T.keine + ' ' + inAnfuehrung(roh)));
    }
    liste.slice(0, MAX_VORSCHLAEGE).forEach(function (t, i) {
      var v = K.videos[t.id];
      var option = el('div', 'bv-vorschlag');
      option.id = vorschlagBox.id + '-' + i;
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.dataset.bvVorschlag = t.id;
      var img = el('img');
      img.src = bildUrl(v.img, 200);
      img.alt = '';
      img.width = 96;
      img.height = 54;
      var text = el('span', 'bv-vorschlag__text');
      var meta = el('small');
      meta.append(el('span', '', v.p.slice(0, 4)), el('span', '', dauer(v.s)));
      text.append(el('strong', '', v.t), meta);
      option.append(img, text);
      vorschlagBox.appendChild(option);
    });
    if (liste.length > MAX_VORSCHLAEGE) {
      var alle = el('div', 'bv-vorschlag bv-vorschlag--alle', T.alle.replace('{n}', liste.length));
      alle.id = vorschlagBox.id + '-alle';
      alle.setAttribute('role', 'option');
      alle.setAttribute('aria-selected', 'false');
      alle.dataset.bvAlle = '';
      vorschlagBox.appendChild(alle);
    }
    vorschlagBox.hidden = false;
    suchFeld.setAttribute('aria-expanded', 'true');
  }

  function schliesseVorschlaege() {
    if (!vorschlagBox) return;
    vorschlagBox.hidden = true;
    vorschlagBox.replaceChildren();
    vorschlagAktiv = -1;
    if (suchFeld) {
      suchFeld.setAttribute('aria-expanded', 'false');
      suchFeld.removeAttribute('aria-activedescendant');
    }
  }

  function markiereVorschlag(index) {
    var optionen = vorschlagBox.querySelectorAll('[role="option"]');
    if (!optionen.length) return;
    vorschlagAktiv = (index + optionen.length) % optionen.length;
    optionen.forEach(function (o, i) { o.setAttribute('aria-selected', String(i === vorschlagAktiv)); });
    var aktiv = optionen[vorschlagAktiv];
    suchFeld.setAttribute('aria-activedescendant', aktiv.id);
    aktiv.scrollIntoView({ block: 'nearest' });
  }

  function waehleVorschlag(option) {
    if (option.hasAttribute('data-bv-alle')) {
      schliesseVorschlaege();
      suche(suchFeld.value);
      suchFeld.blur();
      return;
    }
    var id = option.dataset.bvVorschlag;
    schliesseVorschlaege();
    leereSuche();
    suchFeld.blur();
    zeige(id, { abspielen: true, verlauf: id !== aktuell });
    scrolleZurBuehne();
  }

  /** alle Treffer als Raster statt der Reihen */
  function suche(eingabe) {
    var roh = String(eingabe || '').trim();
    suchLeeren.hidden = !roh;
    if (roh.length < 2) {
      beendeSuche();
      return;
    }
    var liste = finde(roh);
    if (!root.classList.contains('is-suche')) {
      root.classList.add('is-suche');
      stoppe();
      stoppeHintergrund();
    }
    versteckeVorschau();
    treffer.hidden = false;
    treffer.querySelector('[data-bv-treffer-titel]').textContent =
      (liste.length ? T.treffer : T.keine) + ' ' + inAnfuehrung(roh) + (liste.length ? ' (' + liste.length + ')' : '');
    var ul = treffer.querySelector('[data-bv-treffer-liste]');
    ul.replaceChildren.apply(ul, liste.map(function (t) { return karteFuer(t.id); }).filter(Boolean));
    treffer.querySelector('[data-bv-treffer-leer]').hidden = liste.length > 0;
  }

  function beendeSuche() {
    if (!root.classList.contains('is-suche')) return;
    root.classList.remove('is-suche');
    treffer.hidden = true;
    treffer.querySelector('[data-bv-treffer-liste]').replaceChildren();
    starteHintergrund(aktuell);
  }

  function leereSuche() {
    if (!suchFeld) return;
    suchFeld.value = '';
    suchLeeren.hidden = true;
    schliesseVorschlaege();
    beendeSuche();
  }

  if (suchFeld) {
    if (window.innerWidth < 480) suchFeld.placeholder = T.sucheKurz;
    suchFeld.addEventListener('input', function () {
      clearTimeout(suchTimer);
      suchTimer = setTimeout(function () {
        // steht das Raster schon, aktualisiert es sich beim Tippen; sonst Vorschläge unter dem Feld
        if (root.classList.contains('is-suche')) suche(suchFeld.value);
        else vorschlaege(suchFeld.value);
      }, 100);
    });
    suchFeld.addEventListener('focus', function () {
      if (!root.classList.contains('is-suche') && suchFeld.value.trim().length >= 2) vorschlaege(suchFeld.value);
    });
    suchFeld.addEventListener('keydown', function (e) {
      var offen = !vorschlagBox.hidden;
      if (e.key === 'ArrowDown' && offen) {
        e.preventDefault();
        markiereVorschlag(vorschlagAktiv + 1);
      } else if (e.key === 'ArrowUp' && offen) {
        e.preventDefault();
        markiereVorschlag(vorschlagAktiv - 1);
      } else if (e.key === 'Enter') {
        // markierter Vorschlag wird abgespielt, sonst alle Treffer als Raster
        e.preventDefault();
        if (offen && vorschlagAktiv > -1) {
          waehleVorschlag(vorschlagBox.querySelectorAll('[role="option"]')[vorschlagAktiv]);
        } else {
          schliesseVorschlaege();
          suche(suchFeld.value);
          suchFeld.blur();
        }
      } else if (e.key === 'Escape') {
        if (offen) schliesseVorschlaege();
        else {
          leereSuche();
          suchFeld.blur();
        }
      }
    });
    root.querySelector('[data-bv-suche-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var aktiv = vorschlagAktiv > -1 && vorschlagBox.querySelectorAll('[role="option"]')[vorschlagAktiv];
      if (aktiv) {
        waehleVorschlag(aktiv);
        return;
      }
      schliesseVorschlaege();
      suche(suchFeld.value);
      suchFeld.blur();
    });
    // mousedown statt click: sonst schließt das Verlassen des Feldes die Liste vor dem Klick
    vorschlagBox.addEventListener('mousedown', function (e) {
      var option = e.target.closest('[role="option"]');
      if (!option) return;
      e.preventDefault();
      waehleVorschlag(option);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-bv-suche-form]')) schliesseVorschlaege();
    });
    suchLeeren.addEventListener('click', function () {
      leereSuche();
      suchFeld.focus();
    });
  }

  // ------------------------------------------------------------ Vorschau beim Überfahren einer Karte

  var vorschauId = null;
  var vorschauKoerper = null;
  var wartendKoerper = null;
  var vorschauTimer = null;
  var versteckTimer = null;

  function zeigeVorschau(koerper) {
    var karte = koerper.closest('[data-bv-karte]');
    var id = karte && karte.dataset.bvKarte;
    var v = id && K.videos[id];
    if (!v || !vorschau) return;
    vorschauId = id;
    vorschauKoerper = koerper;

    var bild = el('button', 'bv-vorschau__bild');
    bild.type = 'button';
    bild.dataset.bvVPlay = '';
    bild.setAttribute('aria-label', T.abspielen + ': ' + v.t);
    var img = el('img');
    img.src = bildUrl(v.img, 640);
    img.alt = '';
    bild.appendChild(img);

    var play = el('button', 'bv-vorschau__knopf bv-vorschau__knopf--play');
    play.type = 'button';
    play.dataset.bvVPlay = '';
    play.append(symbol('[data-bv-play] .bv-symbol'), el('span', '', T.abspielen));
    var teilen = el('button', 'bv-vorschau__knopf bv-vorschau__knopf--teilen');
    teilen.type = 'button';
    teilen.dataset.bvTeilen = id;
    teilen.append(symbol('.bv-karte__teilen .bv-symbol'), el('span', '', T.teilen));
    var knoepfe = el('div', 'bv-vorschau__knoepfe');
    knoepfe.append(play, teilen);

    var meta = el('p', 'bv-vorschau__meta');
    meta.append(el('span', '', v.p.slice(0, 4)), el('span', '', dauer(v.s)));
    var inhalt = el('div', 'bv-vorschau__inhalt');
    inhalt.append(knoepfe, el('p', 'bv-vorschau__titel', v.t), meta);
    if (v.d) inhalt.appendChild(el('p', 'bv-vorschau__text', v.d));
    var produktBox = el('div');
    inhalt.appendChild(produktBox);
    vorschau.replaceChildren(bild, inhalt);

    produkteZu(id).then(function (liste) {
      if (vorschauId !== id) return;
      liste.slice(0, 2).forEach(function (p) { produktBox.appendChild(produktKarte(p)); });
    });

    // über dem Vorschaubild der Karte zentrieren, seitlich innerhalb der Seite halten
    var r = koerper.querySelector('.bv-karte__bild').getBoundingClientRect();
    var b = root.getBoundingClientRect();
    var breite = Math.round(Math.min(420, Math.max(320, r.width * 1.45)));
    var links = r.left - b.left + r.width / 2 - breite / 2;
    links = Math.max(12, Math.min(links, b.width - breite - 12));
    var oben = r.top - b.top + r.height / 2 - (breite * 9 / 16) / 2;
    vorschau.style.width = breite + 'px';
    vorschau.style.left = Math.round(links) + 'px';
    vorschau.style.top = Math.round(oben) + 'px';
    vorschau.hidden = false;
    vorschau.style.animation = 'none';
    void vorschau.offsetWidth;
    vorschau.style.animation = '';
  }

  function versteckeVorschau() {
    clearTimeout(vorschauTimer);
    clearTimeout(versteckTimer);
    wartendKoerper = null;
    if (!vorschau || vorschau.hidden) return;
    vorschau.hidden = true;
    vorschau.replaceChildren();
    vorschauId = null;
    vorschauKoerper = null;
  }

  root.addEventListener('mouseover', function (e) {
    if (!mitMaus.matches || !vorschau) return;
    if (vorschau.contains(e.target)) {
      clearTimeout(versteckTimer);
      return;
    }
    var koerper = e.target.closest('.bv-karte__koerper');
    if (!koerper || koerper === wartendKoerper || koerper === vorschauKoerper) return;
    clearTimeout(vorschauTimer);
    wartendKoerper = koerper;
    vorschauTimer = setTimeout(function () {
      wartendKoerper = null;
      zeigeVorschau(koerper);
    }, 320);
  });

  root.addEventListener('mouseout', function (e) {
    if (!vorschau) return;
    var koerper = e.target.closest('.bv-karte__koerper');
    var nach = e.relatedTarget;
    if (koerper && koerper === wartendKoerper && !(nach && koerper.contains(nach))) {
      clearTimeout(vorschauTimer);
      wartendKoerper = null;
    }
    if (!vorschau.hidden && vorschau.contains(e.target) && !(nach && vorschau.contains(nach))) {
      clearTimeout(versteckTimer);
      versteckTimer = setTimeout(versteckeVorschau, 120);
    }
  });

  window.addEventListener('scroll', versteckeVorschau, { passive: true });
  window.addEventListener('resize', versteckeVorschau);

  // ------------------------------------------------------------ Klicks

  root.addEventListener('click', function (e) {
    var teilen = e.target.closest('[data-bv-teilen]');
    if (teilen) {
      e.preventDefault();
      var tid = teilen.dataset.bvTeilen;
      versteckeVorschau();
      oeffneTeilen(tid);
      return;
    }
    if (e.target.closest('[data-bv-v-play]')) {
      var vid = vorschauId;
      versteckeVorschau();
      if (root.classList.contains('is-suche')) leereSuche();
      zeige(vid, { abspielen: true, verlauf: vid !== aktuell });
      scrolleZurBuehne();
      return;
    }
    if (e.target.closest('[data-bv-play]')) {
      abspielen();
      return;
    }
    var pfeil = e.target.closest('[data-bv-pfeil]');
    if (pfeil) {
      var liste = pfeil.parentNode.querySelector('.bv-reihe__liste');
      liste.scrollBy({ left: Number(pfeil.dataset.bvPfeil) * liste.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    var karte = e.target.closest('[data-bv-video]');
    if (karte && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      var id = karte.dataset.bvVideo;
      versteckeVorschau();
      if (root.classList.contains('is-suche')) leereSuche();
      zeige(id, { abspielen: true, verlauf: id !== aktuell });
      scrolleZurBuehne();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') versteckeVorschau();
  });

  window.addEventListener('popstate', function (e) {
    var id = e.state && e.state.bv ? e.state.bv : D.start;
    if (!K.videos[id]) return;
    if (root.classList.contains('is-suche')) leereSuche();
    if (K.videos[id].l !== sprache) setzeSprache(K.videos[id].l, { ohneBuehne: true });
    zeige(id, { verlauf: false });
  });

  // Pfeile nur zeigen, wenn es in die Richtung weitergeht
  root.querySelectorAll('.bv-reihe__liste').forEach(function (liste) {
    var zurueck = liste.parentNode.querySelector('[data-bv-pfeil="-1"]');
    var weiter = liste.parentNode.querySelector('[data-bv-pfeil="1"]');
    function pruefe() {
      zurueck.hidden = liste.scrollLeft < 8;
      weiter.hidden = liste.scrollLeft + liste.clientWidth > liste.scrollWidth - 8;
    }
    liste.addEventListener('scroll', function () {
      pruefe();
      versteckeVorschau();
    }, { passive: true });
    window.addEventListener('resize', pruefe);
    pruefe();
  });

  // ------------------------------------------------------------ Teilen

  var teilId = null;
  var teilSprache = null;

  function oeffneTeilen(id) {
    var v = K.videos[id];
    if (!v || !dialog) return;
    teilId = id;
    teilSprache = v.l;
    var vers = fassungen(id);

    var box = dialog.querySelector('[data-bv-d-sprachen]');
    var optionen = dialog.querySelector('[data-bv-d-optionen]');
    optionen.replaceChildren();
    box.hidden = K.languages.length < 2;
    K.languages.forEach(function (l) {
      var label = el('label', 'bv-option');
      var input = el('input');
      input.type = 'radio';
      input.name = 'bv-teilsprache';
      input.value = l.code;
      input.checked = l.code === teilSprache;
      input.disabled = !vers[l.code];
      var span = el('span', '', l.label);
      span.lang = l.code;
      if (!vers[l.code]) span.appendChild(el('small', '', T.fehlt));
      label.append(input, span);
      optionen.appendChild(label);
    });

    fuelleTeilen();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function fuelleTeilen() {
    var vid = fassungen(teilId)[teilSprache] || teilId;
    var v = K.videos[vid];
    var link = teilLink(vid, teilSprache);
    var satz = TEILTEXT[teilSprache] || TEILTEXT.en;
    var text = satz + ': ' + v.t;

    dialog.querySelector('[data-bv-d-titel]').textContent = v.t;
    dialog.querySelector('[data-bv-d-bild]').src = bildUrl(v.img, 240);
    dialog.querySelector('[data-bv-d-link]').value = link;
    dialog.querySelector('[data-bv-d-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(text + '\n' + link);
    dialog.querySelector('[data-bv-d-mail]').href = 'mailto:?subject=' + encodeURIComponent(v.t) + '&body=' + encodeURIComponent(text + '\n\n' + link);
    dialog.querySelector('[data-bv-d-facebook]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link);
    var mehr = dialog.querySelector('[data-bv-d-mehr]');
    mehr.hidden = !navigator.share;
    mehr.onclick = function () {
      navigator.share({ title: v.t, text: text, url: link }).catch(function () {});
    };
    var kopieren = dialog.querySelector('[data-bv-d-kopieren]');
    kopieren.classList.remove('is-kopiert');
    kopieren.querySelector('span').textContent = T.kopieren;
  }

  if (dialog) {
    dialog.addEventListener('change', function (e) {
      if (e.target.name === 'bv-teilsprache') {
        teilSprache = e.target.value;
        fuelleTeilen();
      }
    });
    dialog.querySelector('[data-bv-d-schliessen]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.querySelector('[data-bv-d-link]').addEventListener('focus', function (e) { e.target.select(); });
    dialog.querySelector('[data-bv-d-kopieren]').addEventListener('click', function () {
      var feld = dialog.querySelector('[data-bv-d-link]');
      var knopf = this;
      var fertig = function () {
        knopf.classList.add('is-kopiert');
        knopf.querySelector('span').textContent = T.kopiert;
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(feld.value).then(fertig, function () {
          feld.select();
          if (document.execCommand('copy')) fertig();
        });
      } else {
        feld.select();
        if (document.execCommand('copy')) fertig();
      }
    });
  }

  // ------------------------------------------------------------ Start

  var adresse = new URLSearchParams(location.search);
  // ?lang=en auf der Übersicht wählt die Sprache vor
  var gewuenscht = adresse.get('lang');
  if (gewuenscht && gewuenscht !== sprache && sprachDaten(gewuenscht) && !D.seiteIstVideo) {
    setzeSprache(gewuenscht, { verlauf: false });
  }
  history.replaceState({ bv: D.seiteIstVideo ? D.start : null }, '');
  if (aktuell) produkte(aktuell);
  root.querySelectorAll('[data-bv-karte="' + aktuell + '"]').forEach(function (k) { k.classList.add('is-aktiv'); });

  // ?q=… öffnet direkt die Suche
  if (suchFeld && adresse.get('q')) {
    suchFeld.value = adresse.get('q');
    suche(suchFeld.value);
  }

  // PayPal-Hinweis unter dem Footer (App-Einbettung) steht hier auf dunklem Grund; PayPal zeichnet ihn bei Änderung neu
  document.querySelectorAll('[data-pp-message][data-pp-style-text-color="black"]').forEach(function (m) {
    m.setAttribute('data-pp-style-text-color', 'white');
  });

  // Hintergrundvideo erst nach dem Laden der Seite, damit das Titelbild zuerst steht
  function nachDemLaden(fn) {
    if (document.readyState === 'complete') setTimeout(fn, 300);
    else window.addEventListener('load', function () { setTimeout(fn, 300); });
  }
  nachDemLaden(function () { if (aktuell) starteHintergrund(aktuell); });

  if (buehne && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (eintraege) {
      hintergrundLaeuft(eintraege[0].isIntersecting && !document.hidden);
    }).observe(buehne);
  }
  document.addEventListener('visibilitychange', function () {
    hintergrundLaeuft(!document.hidden);
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (!hintergrundErlaubt()) stoppeHintergrund();
    else if (aktuell) starteHintergrund(aktuell);
  });
})();
